"use strict";

exports.__esModule = true;
exports.default = void 0;

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */


  return result;
};

var _default = mapValues;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/recompose/utils/mapValues.js
// module id = 1768
// module chunks = 0